<script setup>
import { useTheme } from '@/composables/useTheme'

// Initialize theme immediately before component rendering
const { isDark, toggleTheme } = useTheme()
</script>

<template>
  <router-view />
</template>
